import React from 'react';

const RoundMinusIcon = () => (
  <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M5.38335 16.4688C5.38335 10.366 10.3306 5.41875 16.4334 5.41875C22.5361 5.41875 27.4834 10.366 27.4834 16.4688C27.4834 22.5715 22.5361 27.5188 16.4334 27.5188C10.3306 27.5188 5.38335 22.5715 5.38335 16.4688ZM16.4334 3.71875C9.39172 3.71875 3.68335 9.42712 3.68335 16.4688C3.68335 23.5104 9.39172 29.2188 16.4334 29.2188C23.475 29.2188 29.1834 23.5104 29.1834 16.4688C29.1834 9.42712 23.475 3.71875 16.4334 3.71875ZM11.1445 15.6188C10.675 15.6188 10.2945 15.9993 10.2945 16.4688C10.2945 16.9382 10.675 17.3188 11.1445 17.3188H21.7222C22.1917 17.3188 22.5722 16.9382 22.5722 16.4688C22.5722 15.9993 22.1917 15.6188 21.7222 15.6188H11.1445Z" fill="#DE3746" />
  </svg>

);

export default RoundMinusIcon;
